import { useEffect, useState } from 'react';

export default function Hero() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-screen w-full overflow-hidden">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="flex items-center justify-between h-20">
            <div className="flex items-center">
              <span className={`font-serif text-2xl tracking-tight transition-colors ${scrolled ? 'text-gray-900' : 'text-white'}`}>
                Laib &amp; Liebe
              </span>
            </div>
            <div className="hidden md:flex items-center space-x-8">
              <button 
                onClick={() => scrollToSection('angebote')}
                className={`text-sm font-light tracking-wide transition-colors cursor-pointer whitespace-nowrap ${scrolled ? 'text-gray-800 hover:text-amber-600' : 'text-white hover:text-amber-300'}`}
              >
                Angebote
              </button>
              <button 
                onClick={() => scrollToSection('kontakt')}
                className={`text-sm font-light tracking-wide transition-colors cursor-pointer whitespace-nowrap ${scrolled ? 'text-gray-800 hover:text-amber-600' : 'text-white hover:text-amber-300'}`}
              >
                Kontakt
              </button>
              <button 
                onClick={() => scrollToSection('cta')}
                className="px-6 py-2.5 bg-amber-600 text-white text-sm font-light tracking-wide hover:bg-amber-700 transition-colors rounded-md cursor-pointer whitespace-nowrap"
              >
                Event anfragen
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src="https://static.readdy.ai/image/b8e780ba66506b26d5241a449daefe81/6e31202b6acc995dc8dcdd96dbcb8c75.png" 
          alt="Authentic Italian Pasta Art" 
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex items-center justify-center">
        <div className="text-center px-6 max-w-5xl mx-auto w-full">
          <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl text-white mb-6 tracking-tight leading-tight">
            Laib &amp; Liebe
          </h1>
          <p className="text-lg md:text-xl text-gray-200 font-light tracking-wide max-w-2xl mx-auto mb-12">
            Erleben Sie exklusives italienisches Catering mit Live-Cooking im Parmesanlaib
          </p>
          <button 
            onClick={() => scrollToSection('angebote')}
            className="px-10 py-4 bg-amber-600 text-white text-base font-light tracking-wide hover:bg-amber-700 transition-all duration-300 rounded-md cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl"
          >
            Unsere Angebote entdecken
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white/70 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}
